import { Component, inject } from '@angular/core';
import { FIELD_EXTRA_DATA } from '@app/core/model/other/field-config';

@Component({
  selector: 'assets-map-tooltip',
  templateUrl: './assets-map-tooltip.component.html',
  styleUrls: ['./assets-map-tooltip.component.scss'],
  standalone: false
})
export class AssetsMapTooltipComponent {
  protected data = inject<{ assetName: string, propertyValueMessage: string, propertyValue: string }>(FIELD_EXTRA_DATA);
}
